export const UserChannel = [
    { value: "partner_channel", label: "Partner Channel" },
    { value: "sales_channel", label: "Sales Channel" },
    { value: "isv_channel", label: "ISV Channel" },
];
